<template lang="pug">
.empty-subscribe-modal
  y-dialog(v-model="showModal" max-width="400px" persistent)
    v-card
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        v-card-title(style="height:56px;")
          .h6.basic800--text {{ trialEnded ? $t('trial_ended') : $t('account_suspended') }}
        v-card-text
          .p2.primary400--text(v-if="authMember.id === company.primary_owner")
            span(v-if="hasPendingBills") {{ $t('please_pay_pending') }}
            span(v-else) {{ $t('please_subscribe') }}
          .p2.primary400--text(v-else)
            span {{ $t('please_contact_admin') }}
        v-card-actions(v-if="authMember.id === company.primary_owner")
          v-spacer
          v-btn(color='white', text @click='clickSkip')
            .button-Aa-small.primary400--text {{ $t('later') }}
          v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="nextStep")
            .button-AA-small.basic100--text {{ $t('next') }}
        v-card-actions(v-else)
          v-spacer
          v-btn(color='white', text @click='clickSkip')
            .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "EmptySubscriptionModal",
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    hasPendingBills: false,
    contract : ''
  }),
  computed: {
    ...mapState('subscriptions', ['yezzaTrial', 'landingPageTrial', 'yBooksTrial']),
    authMember () {
      return this.$store.state.user.member
    },
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    trialEnded () {
      if ((this.yezzaTrial.value && this.yezzaTrial.data.expired) || (this.landingPageTrial.value && this.landingPageTrial.data.expired) || (this.yBooksTrial.value && this.yBooksTrial.data.expired)) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchPendingBills()
    this.fetchSubscription()
  },
  methods: {
    fetchPendingBills () {
      this.isFetching = true
      let url = `/subscription/bills/?page=1&page_size=12&company=${this.company.id}&ordering=-created&paid=false`
      this.$axios.get(url)
        .then((response) => {
          const totalCount = response.data.count
          if (totalCount !== 0) {
            this.hasPendingBills = true
          }
        })
        .catch(() => {})
        .finally(() => { this.isFetching = false })
    },
    fetchSubscription () {
      this.isFetching = true
      let url = `/subscription/subscriptions?company=${this.company.id}&terminated=false&ordering=start_date&expand=contract&page_size=1000`
      this.$axios.get(url)
        .then((response) => {
          this.contract = response.data.results[0].contract.code
        })
        .catch(() => {})
        .finally(() => { this.isFetching = false })
    },
    clickSkip () {
      this.$router.push('/companies/')
    },
    nextStep () {
      if (this.hasPendingBills) {
        this.$router.push('/admin/billing/bills')
      } else if (this.contract.includes('YZ_CLINIC')) {
        this.$router.push('/admin/billing/clinic-subscription')
      } else if (this.contract.includes('YZ_REVIEW')) {
        this.$router.push('/admin/billing/review-subscription')
      } else {
        this.$router.push('/admin/billing/subscription')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "please_pay_pending": "Please pay your pending bill to continue.",
    "please_subscribe": "Please subscribe to continue.",
    "please_contact_admin": "Please contact your admin and notify them to renew subscription.",
    "later": "Later",
    "account_suspended": "Please proceed to Subscription",
    "trial_ended": "Trial Ended"
  },
  "id": {
    "please_pay_pending": "Harap bayar tagihan kamu yang tertunda untuk melanjutkan.",
    "please_subscribe": "Silakan berlangganan untuk terus menggunakan Yezza",
    "please_contact_admin": "Silakan hubungi admin kamu dan beri tahu mereka untuk memperbarui langganan.",
    "later": "Nanti",
    "account_suspended": "Please proceed to Subscription",
    "trial_ended": "Trial sudah tamat"
  }
}
</i18n>
